import React, { useState, useEffect } from "react";

import { getStock } from "../../../api/stock/getStockApi.js";
import StockListPage from "../../Stocks/StockListPage.js";

const StockGridDetails = () => {
  const [stockData, setStockData] = useState([]);

  useEffect(() => {
    const fetchStockData = async () => {
      try {
        const response = await getStock();
        const firstThreeRows = response.data.data.slice(0, 4); // Get the first 3 rows
        setStockData(firstThreeRows); // Update state with the sliced data
      } catch (error) {
        console.error("Error fetching stock data:", error);
      }
    };

    fetchStockData(); // Call the function to fetch data when the component mounts
  }, []);

  return (
    <React.Fragment>
      <div className="candidate-list">
        <StockListPage stockData={stockData} />
      </div>
    </React.Fragment>
  );
};

export default StockGridDetails;
